module.exports = __webpack_public_path__ + "img/icon_IPFS_outlined.cf0ac5e3.svg";